import React from 'react';
import QuestionAndInputs from './QuestionAndInputs';
import { ConditionalRichText } from '../../../templating/ConditionalRichText';
export default function DetailsPage({ page }) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row two-column_66-33", "data-testid": `two-column_66-33_layout` },
            React.createElement("div", { className: "col-8", "data-testid": "left-column" },
                React.createElement(PrintButton, null),
                page.elements.content.linkedItems.map((content) => (React.createElement(ConditionalRichText, { key: content.system.codename, contentItem: content })))),
            React.createElement("div", { className: "col-4", "data-testid": "right-column" },
                React.createElement(QuestionAndInputs, { page: page })))));
}
function PrintButton() {
    return (React.createElement("button", { onClick: () => window.print(), className: "print-button-icon" },
        React.createElement("i", { className: "fa fa-print" }),
        "Print"));
}
//# sourceMappingURL=index.js.map